import React from 'react'

const NavigationMenuContext = React.createContext({
  menuOpen: false,
  toggleMenuOpen: () => {},
  closeMenu: () => {}
})

export default NavigationMenuContext
